import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';
// import Loader from '../loader';

const Earth = () => {
  const earth = useGLTF('./animated-earth/scene.gltf');

  return (
    <primitive object={earth.scene} scale={3} position-y={0} rotation-y={0} />
  );
};

const EarthCanvas = () => {
  return (
    <Canvas
      shadows
      frameloop="always"
      gl={{ preserveDrawingBuffer: true }}
      camera={{
        fov: 45,
        near: 0.1,
        far: 200,
        position: [-7, 3, 6],
      }}>
      <Suspense fallback={null}>
        <OrbitControls
          autoRotate
          enableZoom={false}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
        <directionalLight
          position={[100, 50, -50]}
          intensity={2.5}
          castShadow
          shadow-mapSize-width={2048}
          shadow-mapSize-height={2048}
          color="#a2a2a2"
        />
        <ambientLight intensity={0.35} color="#9d9d9d" />
        <Earth />
      </Suspense>
    </Canvas>
  );
};

export default EarthCanvas;
